'use client';

import { useInsforge } from './provider';
import { CreateSessionResponse, CreateUserResponse } from '@insforge/shared-schemas';
import type { InsforgeUser } from '@insforge/shared';

/**
 * Next.js specific hooks - implemented locally to avoid Context duplication
 */

export function useAuth(): {
  signIn: (email: string, password: string) => Promise<CreateSessionResponse | { error?: string }>;
  signUp: (email: string, password: string) => Promise<CreateUserResponse | { error?: string }>;
  signOut: () => Promise<void>;
  isLoaded: boolean;
  isSignedIn: boolean | undefined;
} {
  const { signIn, signUp, signOut, isLoaded, isSignedIn } = useInsforge();
  return { signIn, signUp, signOut, isLoaded, isSignedIn };
}

export function useUser(): {
  user: InsforgeUser | null | undefined;
  isLoaded: boolean;
} {
  const { user, isLoaded } = useInsforge();
  return { user, isLoaded };
}

export function usePublicAuthConfig() {
  const { getPublicAuthConfig } = useInsforge();
  return { getPublicAuthConfig };
}
